import * as React from 'react';

import * as ramda from 'ramda';

import {SelectInline} from 'shells/select-inline/select-inline';

// @ts-expect-error
import {getFormModelsFromRelationships} from '../../../../entities/helpers';

import {EntitySelect} from './entity-select';

type Props = {
    name: string;
    hasDescription?: boolean;
    entityType: string;
    value: string;
    excludedOptions: string[];
    nullOptionText?: string;
    relationships?: string[];
    options?: any[];
    allowAny: boolean;
    onChange: (data: string) => any;
    onClearValue: () => void;
};

const VALID_TYPES = ['accounts', 'contacts', 'leads'];

export class FormRelationship extends React.Component<Props> {
    static defaultProps = {
        allowAny: false,
    };

    render() {
        if (this.props.relationships) {
            const entityRelationships = ramda.intersection(this.props.relationships, VALID_TYPES);

            if (entityRelationships.length) {
                return (
                    <EntitySelect
                        onChange={this.handleEntityChange}
                        types={entityRelationships}
                        autoFocus={false}
                        value={this.props.value}
                        onClearValue={this.props.onClearValue}
                    />
                );
            }
        }

        const models = this.getNullOptions()
            .concat(this.getAnyOptions())
            .concat(this.getModels())
            .filter((model) => {
                return (
                    this.props.value === model.id || !this.props.excludedOptions.includes(model.id)
                );
            });

        const selectValue = models.find((model) => {
            let value = this.props.value;

            // If we're looking at our milestone filter, we need
            // to convert relic saved filters with api ids of `1-milestones`
            // to `1-stages`, since our enum options are all key'd
            // with 1-stages, not 1-milestones. This sucks, but it's better
            // than running a delta and hoping no one has URL's bookmarked.
            if (this.props.name === 'milestone' && value) {
                value = value.replace('-milestones', '-stages');
            }

            return model.id === value;
        });

        return (
            <SelectInline
                tokenizedStyle={this.props.name === 'tags' ? 'colorName' : 'dark'}
                isTwoLine={this.props.hasDescription}
                autoFocus={true}
                options={models}
                value={selectValue}
                onChange={this.handleSelectChange}
                onClearValue={this.props.onClearValue}
            />
        );
    }

    getNullOptions = () => {
        return this.props.nullOptionText ? [{id: '-', name: this.props.nullOptionText}] : [];
    };

    getAnyOptions = () => {
        return this.props.allowAny ? [{id: '*', name: 'Any'}] : [];
    };

    getModels = () => {
        const {name, options, relationships} = this.props;

        if (options) {
            return options.map((opt) => {
                return opt && opt.id && opt.name
                    ? {
                          id: opt.id,
                          type: 'enum',
                          name: opt.name,
                      }
                    : {
                          id: opt,
                          type: 'enum',
                          name: opt,
                      };
            });
        }

        return getFormModelsFromRelationships(relationships, this.props.entityType, name);
    };

    handleSelectChange = (
        value?: {
            id: string;
        } | null
    ) => {
        if (value) {
            this.props.onChange(value.id);
        } else {
            this.props.onClearValue();
        }
    };

    handleEntityChange = (value?: string | null) => {
        if (value) {
            this.props.onChange(value);
        } else {
            this.props.onClearValue();
        }
    };
}
